import React from 'react';
import { Grid, makeStyles, useTheme } from '@material-ui/core';
import {
  HomePageCompanyLogo,
  HomePageToolkit,
  WelcomeTitle,
} from '@backstage/plugin-home';
import { Content, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import CategoryIcon from '@material-ui/icons/Category';
import ExploreIcon from '@material-ui/icons/Explore';
import { MyOwnedEntitiesCard, StarredEntitiesWithLimit } from '@internal/backstage-plugin-home-enhancements';

const useStyles = makeStyles(theme => ({
  searchBar: {
    display: 'flex',
    maxWidth: '60vw',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    margin: '0 auto',
  },
  welcomeTitle: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
}));

const useLogoStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
  },
  img: {
    width: 'auto',
    height: 120,
    maxWidth: '400px',
  },
}));

export const HomePage = () => {
  const classes = useStyles();
  const logoStyles = useLogoStyles();
  const theme = useTheme();
  const isDarkMode = theme.palette.type === 'dark';

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={6}>
            {/* Welcome Section */}
            <Grid container item xs={12} justifyContent="center">
              <Grid item xs={12} className={classes.welcomeTitle}>
                <WelcomeTitle />
              </Grid>
            </Grid>

            {/* Logo - Using WeArePlanet custom logo */}
            <Grid container item xs={12} justifyContent="center">
              <HomePageCompanyLogo
                className={logoStyles.container}
                logo={
                  <img
                    src={isDarkMode ? "/planet_logo.svg" : "/planet_logo_black.svg"}
                    alt="WeArePlanet"
                    className={logoStyles.img}
                  />
                }
              />
            </Grid>

            {/* Search Bar */}
            <Grid container item xs={12} justifyContent="center">
              <Grid item xs={12} md={6}>
                <HomePageSearchBar
                  classes={{ root: classes.searchBar }}
                  placeholder="Search"
                />
              </Grid>
            </Grid>

            {/* Quick Links and Starred Entities */}
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageToolkit
                  title="Quick Links"
                  tools={[
                    {
                      url: '/catalog',
                      label: 'Browse Catalog',
                      icon: <CategoryIcon />,
                    },
                    {
                      url: '/tech-radar',
                      label: 'Tech Radar',
                      icon: <ExploreIcon />,
                    },
                  ]}
                />
              </Grid>

              {/* Starred Entities */}
              <Grid item xs={12} md={6}>
                <StarredEntitiesWithLimit />
              </Grid>
            </Grid>

            {/* My Owned Entities - full width below */}
            <Grid container item xs={12}>
              <Grid item xs={12}>
                <MyOwnedEntitiesCard />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
